import React, { useEffect, useMemo, useState } from "react";
import { DA_DeliveryInfoModalData } from "@interfaces/deliveryInfoModalData.interface";
import { DA_Text } from "@danishagro/shared/src/components/atoms/Text/Text.component";
import { DA_Title } from "@danishagro/shared/src/components/atoms/Title/Title.component";
import { DA_InlineLink } from "@danishagro/shared/src/components/atoms/InlineLink/InlineLink.component";
import { getDeliveryInfoModalContent } from "@helpers/getDeliveryInfoModalContent.helper";
import { DA_Table } from "@danishagro/shared/src/components/atoms/Table/Table.component";
import { useTranslations } from "@danishagro/shared/src/contexts/translations/translations.context";
import { TableRowSimple } from "@danishagro/shared/src/components/atoms/Table/TableProps";
// Import style
import S from "./BottomSheetDeliveryInfoV1.module.scss";

export interface V1Props {
    specialFreightOverlayText?: string;
}

export const V1 = (props: V1Props) => {
    const [modalContent, setModalContent] = useState<DA_DeliveryInfoModalData>();
    const { getDictionaryString } = useTranslations();

    useEffect(() => {
        getDeliveryInfoModalContent().then((response) => {
            setModalContent(response);
        });
    }, []);

    const columns = [
        { title: getDictionaryString("deliveryInfo.shippingLimits") },
        { title: getDictionaryString("general.price"), alignRight: true },
    ];

    const data: TableRowSimple[] = useMemo(() => {
        return (
            modalContent?.modal?.table?.items?.map((item) => {
                return [
                    { content: item.freightLimit, value: item.freightLimit },
                    { content: item.freightPrice, value: item.freightPrice, alignRight: true },
                ];
            }) || []
        );
    }, [modalContent?.modal?.table?.items]);

    return (
        <div className={S.deliveryContainer}>
            {/* Description */}
            <DA_Text
                html={
                    props.specialFreightOverlayText
                        ? props.specialFreightOverlayText
                        : modalContent?.modal.description
                }
            />

            {/* Table */}
            {modalContent?.modal?.table && (
                <div className={S.tableWrapper}>
                    <DA_Table columns={columns} data={data} noSwipeOrRotate />
                </div>
            )}

            {/* Bottom description */}
            {modalContent?.modal.bottomDescription && (
                <DA_Text html={modalContent?.modal.bottomDescription} />
            )}

            {/* Links */}
            {modalContent?.modal.linkBoxes.map((item, index) => (
                <div key={index} className={S.linkbox}>
                    {item.links?.map((link, index) => (
                        <div key={index} className={S.links}>
                            {link.title && <DA_Title h3>{link.title}</DA_Title>}
                            <DA_InlineLink
                                target="_blank"
                                className={S.linkTag}
                                title={link.linkText}
                                href={link.link}
                            />
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
};
